<header>
  <div class="wrap">
    <h1 class="brand">{{ title }}</h1>
    <div class="meta">
      <span>{{ (userName$ | async) ?? 'Investor' }}</span>
      <button class="logout" type="button" (click)="logout()">Logout</button>
    </div>
  </div>
</header>
